<template>
    <div>
        <ob1-popin-modal2
            :id="id"
            :aria-labelledby="'choisir'"
        >
            <div class="row">
                <div class="col-12 col-xl-6">
                    <!--/* title */-->
                    <div id="choisir" class="h4 d-xl-none pb-2">
                        {{ accessory.name }}
                    </div>
                    <div class="row">
                        <div class="col" />
                        <div class="col-12 col-sm-8 col-xl-12">
                            <ob1-carrousel
                                v-if="currentVersion.pictures.length > 0"
                                :id="id + '-gallery'"
                                :images="currentVersion.pictures"
                                :is-product-sheet="true"
                                :with-zoom="true"
                            />
                            <div v-if="accessory.das" class="d-flex justify-content-center mb-1">
                                <das-bundle-accessories
                                    v-if="accessory.das"
                                    :head="accessory.das.head"
                                    :limbs="accessory.das.member"
                                    :prefix="dasDto"
                                    :trunk="accessory.das.trunk"
                                />
                            </div>
                        </div>
                        <div class="col" />
                    </div>
                </div>

                <div class="col-12 col-xl-6">
                    <!--/* title */-->
                    <div class="h4 d-none d-xl-block">
                        {{ accessory.name }}
                    </div>

                    <ob1-separateur v-if="showDeclinaisonName" />
                    <div class="row">
                        <div class="col-12 col-md-6 col-xl-12">
                            <div
                                v-if="showDeclinaisonName"
                                class="fw-bold no-signature standard my-1"
                                v-html="currentVersion.name"
                            />
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12 col-md-6 col-xl-12">
                            <!--/*Pastilles + capacités + longueurs*/-->
                            <div v-if="accessory.versions.length > 1" class="item-chips-capas">
                                <ob1-pastilles-de-couleurs
                                    v-if="allColors.length > 1"
                                    :id="id + '-colors'"
                                    ref="pastilles-de-couleurs"
                                    :class="!showDeclinaisonName ? 'mt-2' : null"
                                    :colors="allColors"
                                    :default-color="currentVersion.color.code"
                                    class="mb-1"
                                    @ob1-pastilles-de-couleurs-click="changeSelectedColor"
                                />

                                <fieldset
                                    v-if="allCapacities.length > 1"
                                    :class="allColors.length > 1 ? 'mb-1' : 'mt-1 mb-1'"
                                >
                                    <legend class="visually-hidden">
                                        Capacités disponibles
                                    </legend>
                                    <ob1-chips
                                        v-for="capacity in allCapacities"
                                        :id="id + '-capacity-' + capacity.capacity"
                                        :key="'capa-' + id + capacity.capacity"
                                        :disable-uncheck="true"
                                        :is-checked="capacity.checked"
                                        :is-choice-version="true"
                                        :is-disabled="!capacity.inStock"
                                        :label="capacity.capacity"
                                        @ob1-chips-click="changeSelectedCapacity($event, capacity.capacity)"
                                    />
                                </fieldset>
                                <fieldset
                                    v-if="allLengths.length > 1"
                                    :class="allCapacities.length > 1 || allColors.length > 1 ? 'mb-1' : 'mt-1 mb-1'"
                                >
                                    <legend class="visually-hidden">
                                        Longueurs disponibles
                                    </legend>
                                    <ob1-chips
                                        v-for="(length, index) in allLengths"
                                        :id="id + '-length-' + length.length"
                                        :key="'length-' + id + length.length + index"
                                        ref="access-length"
                                        :disable-uncheck="true"
                                        :is-checked="length.checked"
                                        :is-choice-version="true"
                                        :is-disabled="!length.inStock"
                                        :label="length.length"
                                        @ob1-chips-click="changeSelectedLength($event, length.length)"
                                    />
                                </fieldset>
                            </div>
                            <div v-if="currentVersion.banner" class="promo">
                                <ob1-tag :label="currentVersion.banner" />
                            </div>
                            <div class="price">
                                <ob1-prix-terminal
                                    :total-price-with-promo="priceWithPromo"
                                    :total-price-without-promo="priceWithoutDiscount"
                                    class="mb-0"
                                />
                            </div>
                            <eco-part-private-copying
                                v-if="currentVersion.ecoParticipation"
                                :eco-part-label="currentVersion.ecoParticipation.label"
                                :private-copying-label="currentVersion.ecoParticipation.privateCopyingLabel"
                                :private-copying-link="currentVersion.ecoParticipation.privateCopyingLink"
                                :private-copying-link-label="currentVersion.ecoParticipation.privateCopyingLinkLabel"
                                :target="currentVersion.ecoParticipation.modal.target"
                            >
                                <template #link>
                                    <ob1-liens
                                        :is-button="true"
                                        :modal-id="'popin-ecopart-' + id"
                                        :text="currentVersion.ecoParticipation.linkLabel"
                                        class="fw-normal p-0"
                                        type="button"
                                        @ob1-liens-click="ecoPartLinkHandler"
                                    />
                                </template>
                            </eco-part-private-copying>
                        </div>

                        <div class="col-12 col-sm-10 col-md-6 col-xl-12 pt-2 pb-1">
                            <promo-odr
                                v-if="hasPromoOrOdr"
                                :promo-amount-in-cents="promoAmountInCents"
                                :promo-end-date="promoEndDate"
                                :odr-amount-in-cents="odrAmountInCents"
                                :odr-start-date="odrStartDate"
                                :odr-end-date="odrEndDate"
                                :bundle-pack-name="bundlePackName"
                                :promo-odr-messages="compactPromoMessagesDto"
                                :link-label="compactPromoMessagesDto.linkLabel"
                                :modal-id="promoOdrPopinId"
                                @promo-odr-click="compactPromoOdrLinkHandler"
                            />
                        </div>
                    </div>

                    <div v-if="withButtonCta" class="row mb-3">
                        <div class="col-12">
                            <p>
                                <strong>{{ currentVersion.availabilityStatus }}</strong>
                            </p>
                            <ob1-boutons
                                v-if="currentVersion.idSeo.value === displayVersionIdSeo && isAdded"
                                :is-disabled="false"
                                :is-primary="true"
                                :label="deleteButtonLabel"
                                @ob1-boutons-click="onDeleteButtonClick"
                            />
                            <ob1-boutons
                                v-else
                                :is-disabled="false"
                                :is-primary="true"
                                :label="isAdded ? replaceButtonLabel : addButtonLabel"
                                @ob1-boutons-click="onAddButtonClick"
                            />
                        </div>
                    </div>
                </div>
                <div v-if="legalNoticesDas !== null && accessory.das !== null" class="col-12 pb-1">
                    <p v-html="legalNoticesDas.text" />
                </div>
                <div v-if="legalNoticesSav !== null" class="col-12 pb-1">
                    <ob1-separateur class="mb-2 mb-xl-3" />
                    <h4 v-html="legalNoticesSav.title" />
                    <p v-html="legalNoticesSav.text" />
                </div>

                <div class="col-12">
                    <ob1-separateur class="mb-2 mb-xl-3" />
                    <h4 v-if="accessory.longDescriptionTitle != null" v-html="accessory.longDescriptionTitle" />
                    <p v-if="accessory.longDescription != null" v-html="accessory.longDescription" />
                </div>

                <div class="col-12">
                    <accessory-legal-notices
                        v-if="otherLegalNotices.length > 0"
                        :legal-notices="otherLegalNotices"
                        :title="'Mentions'"
                        class="pb-1"
                    />
                </div>
            </div>
        </ob1-popin-modal2>

        <!--/* Popin Ecopart */-->
        <ob1-popin-modal2
            v-if="currentVersion.ecoParticipation"
            :id="'popin-ecopart-' + id"
            :class="'popin-'+ id"
            :aria-labelledby="'popin-ecopart-' + id + '-modal'"
        >
            <h4 :id="'popin-ecopart-' + id + '-modal'">
                {{ currentVersion.ecoParticipation.modal.title }}
            </h4>
            <p v-html="currentVersion.ecoParticipation.modal.text" />
        </ob1-popin-modal2>

        <!--/* Popin Promo + odr compact */-->
        <promo-odr-popin
            v-if="hasPromoOrOdr"
            :promo-amount-in-cents="promoAmountInCents"
            :promo-end-date="promoEndDate"
            :odr-amount-in-cents="odrAmountInCents"
            :odr-start-date="odrStartDate"
            :odr-end-date="odrEndDate"
            :odr-link="odrLink"
            :bundle-pack-name="bundlePackName"
            :device-name="deviceName"
            :device-discounted-price-in-cents="deviceDiscountedPriceInCents"
            :device-price-in-cents="devicePriceInCents"
            :promo-odr-messages="compactPromoMessagesDto"
            :modal-id="promoOdrPopinId"
            :class="'popin-'+ id"
        />
    </div>
</template>

<script>
import AccessoryLegalNotices from "./AccessoryLegalNotices";
import EcoPartPrivateCopying from "./EcoPartPrivateCopying.vue";
import PromoOdr from "../components/PromoOdr";
import PromoOdrPopin from "../components/PromoOdrPopin";
import {ColorSorter} from "../mixins/ColorSorter";
import {VersionSorter} from "../mixins/VersionSorter";
import DasBundleAccessories from "./DasAccessories.vue";

export default {
    components: {
        DasBundleAccessories,
        AccessoryLegalNotices,
        EcoPartPrivateCopying,
        PromoOdr,
        PromoOdrPopin
    },
    mixins: [ColorSorter, VersionSorter],
    props: {
        accessory: {
            type: Object,
            required: true
        },
        displayVersionIdSeo:{
            type: String,
            required: true
        },
        isAdded:{
            type: Boolean,
            required: true
        },
        id: {
            type: String,
            required: true
        },
        //avec ou sans bouton ajouter pour bundle pas de bouton
        withButtonCta: {
            type: Boolean,
            required: false,
            default: true
        },
        dasDto: {
            type: Object,
            required: true
        },
        associatedDeviceForBundle: {
            type: String,
            required: false,
            default: undefined
        },
        compactPromoMessagesDto: {
            type: Object,
            required: true
        },
        isBundle: {
            type: Boolean,
            required: true
        }
    },
    data: function () {
        return {
            currentVersion: this.accessory.versions.find(version => version.idSeo.value === this.displayVersionIdSeo),
            carrousel: null,
        }
    },
    computed: {
        legalNoticesSav() {
            const mentionsSav = this.accessory.legalNotices
                    .filter(mention => mention.type === "SAV");

            if (mentionsSav.length > 0) {
                return mentionsSav[0];
            } else {
                return null;
            }
        },
        legalNoticesDas() {
            return this.accessory.legalNotices
                    .find(mention => mention.type === "DAS");
        },
        otherLegalNotices() {
            return this.accessory.legalNotices
                    .filter(mention => mention.type !== "SAV" && mention.type !== "DAS");
        },
        priceWithoutDiscount() {
            if (this.currentVersion.promoData) {
                return this.currentVersion.priceInCents / 100;
            } else {
                return null;
            }
        },
        priceWithPromo() {
            return this.currentVersion.discountedPriceInCents / 100;
        },
        addButtonLabel() {
            return 'Ajouter'
        },
        deleteButtonLabel() {
            return 'Supprimer'
        },
        replaceButtonLabel() {
            return 'Remplacer'
        },
        allColors() {
            const colors = []
            for (const version of this.accessory.versions) {
                const versionColor = version.color
                if (versionColor && !colors.find(color => color.code === versionColor.code)) {
                    colors.push(
                            {
                                colorName: versionColor.colorName,
                                code: versionColor.code,
                                inputName: versionColor.inputName,
                                isChecked: this.checkedColor !== null && this.checkedColor !== undefined && this.checkedColor.code === versionColor.code
                            }
                    )
                }
            }
            return this.sortColors(colors)
        },
        checkedCapacity() {
            const capacity = this.currentVersion.capacity
            if (capacity !== null && capacity !== undefined) capacity.inStock = this.currentVersion.inStock
            return capacity
        },
        checkedLength() {
            let length = this.currentVersion.length
            if (length !== null && length !== undefined) length.inStock = this.currentVersion.inStock
            return length
        },
        checkedColor() {
            let color = this.currentVersion.color
            if (color !== null && color !== undefined) color.inStock = this.currentVersion.inStock
            return color
        },
        allCapacities() {
            const capacities = []
            for (const capacity of this.accessory.allCapacities) {
                let version = this.accessory.versions.find(version => version.capacity.label === capacity)
                if (version != null) {
                    capacities.push({
                        capacity: version.capacity.label,
                        checked: this.checkedCapacity !== null && this.checkedCapacity !== undefined && this.checkedCapacity.label === version.capacity.label,
                        inStock: version.inStock
                    })
                }
            }
            return capacities
        },
        allLengths() {
            const lengths = []
            for (const version of this.accessory.versions) {
                if (version.length) {
                    lengths.push({
                        length: version.length.label,
                        checked: this.checkedLength !== null && this.checkedLength !== undefined && this.checkedLength.label === version.length.label,
                        inStock: version.inStock
                    })
                }
            }
            return lengths
        },
        showDeclinaisonName() {
            return this.currentVersion.name !== this.accessory.name
        },
        odrStartDate() {
            return this.currentVersion.odrData?.dates.start
        },
        odrEndDate() {
            return this.currentVersion.odrData?.dates.end
        },
        promoEndDate() {
            return this.currentVersion.promoData?.endDate
        },
        promoAmountInCents() {
            return this.currentVersion.promoData?.amountInCents
        },
        odrAmountInCents() {

            return this.currentVersion.odrData?.amountInCents

        },
        odrLink() {
            return this.currentVersion.odrData?.link

        },
        bundlePackName() {
            if (this.associatedDeviceForBundle) {
                return this.associatedDeviceForBundle + " + " + this.currentVersion.name
            }
            return undefined
        },
        deviceDiscountedPriceInCents() {
            return this.currentVersion.discountedPriceInCents
        },
        devicePriceInCents() {
            return this.currentVersion.priceInCents
        },
        deviceName() {
            return this.currentVersion.name
        },
        hasPromoOrOdr() {
            return this.promoAmountInCents || this.odrAmountInCents
        },
        promoOdrPopinId() {
            return `promo-odr-${this.id}`;
        },
    },
    mounted() {
        const elt = document.querySelector(`#${this.id} .ob1-carrousel-product-sheet`);
        if (elt !== null) {
            this.carrousel = new ob1.Carrousel(elt, false)
        }

        // On utilise des fonctionnalités de jquery pour la gestion des modals utilisées dans Boostrap
        // Pour les show et les hide des modals
        if (this.currentVersion.ecoParticipation) {
            $('#' + 'popin-ecopart-' + this.id).on("hidden.bs.modal", this.showAccessoryPopin);
        }
        if (this.hasPromoOrOdr) {
            $('#' + this.promoOdrPopinId).on("hidden.bs.modal", this.showAccessoryPopin);
        }
        this.initPopins()
    },
    updated: function () {
        this.initPopins()
    },
    methods: {
        /**
         * On déplace les popins en bas du main pour eviter un problème d'affichage lorsque les popins sont dans un carousel
         **/
        initPopins: function () {
            const mainSection = document.body.querySelector("main") ||
                document.body.querySelector("*[role=main]");
            const popins = document.querySelectorAll('.popin-' + this.id);
            popins.forEach(popin => {
                if (popin) {
                    mainSection.appendChild(popin);
                }
            });
        },
        // On utilise des fonctionnalités de jquery pour la gestion des modals utilisées dans Boostrap
        // Pour les show et les hide des modals
        showAndHideModal(showId, hideId) {
            $('#' + showId).modal('show');
            $('#' + hideId).modal('hide');
        },
        showAccessoryPopin() {
            $('#' + this.id).modal('show');
        },
        hideAccessoryPopin() {
            $('#' + this.id).modal('hide');
        },
        onAddButtonClick() {
            this.$emit("accessory-add", this.currentVersion.idSeo.value);
            this.hideAccessoryPopin();
        },
        onDeleteButtonClick() {
            this.$emit("accessory-remove");
            this.hideAccessoryPopin();
        },
        ecoPartLinkHandler() {
            this.showAndHideModal('popin-ecopart-' + this.id, this.id);
        },
        compactPromoOdrLinkHandler() {
            if (this.hasPromoOrOdr) {
                this.showAndHideModal(this.promoOdrPopinId, this.id);
            }
        },
        changeSelectedColor(clickedColor) {
            const currentAccessoryLength = this.currentVersion.length ? this.currentVersion.length.label : undefined
            const currentAccessoryCapacity = this.currentVersion.capacity ? this.currentVersion.capacity.label : undefined
            if (currentAccessoryLength && currentAccessoryCapacity) {
                this.currentVersion = this.findVersionByCapacityLengthAndColor(currentAccessoryCapacity, currentAccessoryLength, clickedColor.code)
            } else if (currentAccessoryLength) {
                this.currentVersion = this.findVersionByLengthAndColor(currentAccessoryLength, clickedColor.code, true, false)
            } else if (currentAccessoryCapacity) {
                this.currentVersion = this.findVersionByCapacityAndColor(currentAccessoryCapacity, clickedColor.code, false, true)
            } else {
                this.currentVersion = this.findVersionByColor(clickedColor.code)
            }
        },
        changeSelectedCapacity(event, clickedCapacity) {
            const currentAccessoryColor = this.currentVersion.color ? this.currentVersion.color.code : undefined
            const currentAccessoryLength = this.currentVersion.length ? this.currentVersion.length.label : undefined
            if (currentAccessoryColor && currentAccessoryLength) {
                this.currentVersion = this.findVersionByCapacityLengthAndColor(clickedCapacity, currentAccessoryLength, currentAccessoryColor)
            } else if (currentAccessoryColor) {
                this.currentVersion = this.findVersionByCapacityAndColor(clickedCapacity, currentAccessoryColor, true, false)
            } else if (currentAccessoryLength) {
                this.currentVersion = this.findVersionByCapacityAndLength(clickedCapacity, currentAccessoryLength, true, false)
            } else {
                this.currentVersion = this.findVersionByCapacity(clickedCapacity)
            }
        },
        changeSelectedLength(event, clickedLength) {
            const currentAccessoryColor = this.currentVersion.color ? this.currentVersion.color.code : undefined
            const currentAccessoryCapacity = this.currentVersion.capacity ? this.currentVersion.capacity.label : undefined
            if (currentAccessoryColor && currentAccessoryCapacity) {
                this.currentVersion = this.findVersionByCapacityLengthAndColor(currentAccessoryCapacity, clickedLength, currentAccessoryColor)
            } else if (currentAccessoryColor) {
                this.currentVersion = this.findVersionByLengthAndColor(clickedLength, currentAccessoryColor, false, true)
            } else if (currentAccessoryCapacity) {
                this.currentVersion = this.findVersionByCapacityAndLength(currentAccessoryCapacity, clickedLength, false, true)
            } else {
                this.currentVersion = this.findVersionByLength(clickedLength)
            }
        },
        findVersionByCapacity(capacity) {
            return this.accessory.versions.find(version =>
                    version.capacity.label === capacity
            )
        },
        findVersionByLength(length) {
            return this.accessory.versions.find(version =>
                    version.length.label === length
            )
        },
        findVersionByColor(colorCode) {
            return this.accessory.versions.find(version =>
                    (version.color.code === colorCode.toLowerCase() || version.color.code === colorCode.toUpperCase())
            )
        },
        findVersionByCapacityAndLength(capacity, length, findByCapacity, findByLength) {
            let versionToReturn = null
            versionToReturn = this.accessory.versions.find(version =>
                    version.capacity.label === capacity && version.length.label === length
            )
            if (!versionToReturn && findByCapacity) {
                versionToReturn = this.findVersionByCapacity(capacity)
            } else if (!versionToReturn && findByLength) {
                versionToReturn = this.findVersionByLength(length)
            }
            return versionToReturn
        },
        findVersionByCapacityAndColor(capacity, colorCode, findByCapacity, findByColor) {
            let versionToReturn = null
            versionToReturn = this.accessory.versions.find(version =>
                    version.capacity.label === capacity && (version.color.code === colorCode.toLowerCase() || version.color.code === colorCode.toUpperCase())
            )
            if (!versionToReturn && findByCapacity) {
                versionToReturn = this.findVersionByCapacity(capacity)
            } else if (!versionToReturn && findByColor) {
                versionToReturn = this.findVersionByColor(colorCode)
            }
            return versionToReturn
        },
        findVersionByLengthAndColor(length, colorCode, findByColor, findByLength) {
            //on cherche le duo couleur / nouvelle longueur ou longueur / nouvelle couleur.
            //si on ne trouve pas ce duo, et qu'on a cliqué sur une couleur, on va renvoyer la première version trouvée avec la nouvelle couleur.
            //si on a cliqué sur une longueur, on va renvoyer la première version trouvée avec cette longueur.
            let versionToReturn = null
            versionToReturn = this.accessory.versions.find(version =>
                    version.length.label === length && (version.color.code === colorCode.toLowerCase() || version.color.code === colorCode.toUpperCase())
            )
            if (!versionToReturn && findByLength) {
                const pastilles = this.$refs["pastilles-de-couleurs"]
                versionToReturn = this.findVersionByLength(length)
                pastilles.currentColorCode = versionToReturn.color.code
            } else if (!versionToReturn && findByColor) {
                versionToReturn = this.findVersionByColor(colorCode)
            }
            return versionToReturn
        },
        findVersionByCapacityLengthAndColor(capacity, length, colorCode, findByCapacity, findByLength, findByColor) {
            //si on ne trouve pas le trio capacité/longueur/couleur et qu'on a cliqué sur une capacité, on cherche le duo capacité/longueur ou capacité/couleur. Si on les trouve pas on cherche la première version de la capacité sélectionnée
            //si pas trio capacité/longueur/couleur et clic sur couleur, on cherche duo couleur/capacité ou couleur/longueur. Si on ne les trouve pas, on cherche la première version avec la couleur sélectionnée.
            //si pas trio capacité/longueur/couleur et clic sur longueur, on cherche duo longueur/capacité ou longueur/couleur. Si on ne les trouve pas, on cherche la première version avec la longueur sélectionnée
            let versionToReturn = null
            versionToReturn = this.accessory.versions.find(version =>
                    version.length.label === length && (version.color.code === colorCode.toLowerCase() || version.color.code === colorCode.toUpperCase()) && version.capacity.label === capacity
            )
            if (!versionToReturn && findByCapacity) {
                versionToReturn = this.findVersionByCapacityAndLength(capacity, length, true, false)
                if (!versionToReturn) {
                    versionToReturn = this.findVersionByCapacityAndColor(capacity, length, true, false)
                }
            } else if (!versionToReturn && findByLength) {
                versionToReturn = this.findVersionByLengthAndColor(length, colorCode, false, true)
                if (!versionToReturn) {
                    versionToReturn = this.findVersionByCapacityAndLength(capacity, length, false, true)
                }
            } else if (!versionToReturn && findByColor) {
                versionToReturn = this.findVersionByLengthAndColor(length, colorCode, true, false)
                if (!versionToReturn) {
                    versionToReturn = this.findVersionByCapacityAndColor(capacity, colorCode, false, true)
                }
            }
            return versionToReturn
        }
    }
}
</script>
